<template src="./template.html"/>

<script>
export default {
  name: 'issue',
  props: {
    username: String,
    issue: String
  }
}
</script>

<style lang="scss" src="./style.scss" scoped />
